import React, { Component } from 'react';

import Helmet from './Helmet';

export default class CannyHelmet extends Component {
  render() {
    return <Helmet defaultIcons title="Canny" />;
  }
}
